export default function initContactForm() {
    const form = document.querySelector('.hr-contact-form');
    if (!form) return;

    form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const btn = form.querySelector('.hr-contact-submit');
        const originalText = btn.querySelector('.hr-contact-submit-text')?.textContent;
        if (btn.querySelector('.hr-contact-submit-text')) {
            btn.querySelector('.hr-contact-submit-text').textContent = 'Sending…';
        }
        btn.disabled = true;

        try {
            const res = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                headers: { Accept: 'application/json' }
            });

            if (res.ok) {
                form.style.display = 'none';
                const success = document.querySelector('.hr-contact-success');
                if (success) success.style.display = 'block';
            } else {
                throw new Error('Form submission failed');
            }
        } catch {
            alert('Something went wrong. Please try again.');
            if (btn.querySelector('.hr-contact-submit-text')) {
                btn.querySelector('.hr-contact-submit-text').textContent = originalText || 'Send Message';
            }
            btn.disabled = false;
        }
    });
}
